/* eslint-disable no-shadow */
/* eslint-disable no-nested-ternary */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable max-len */
/* eslint-disable no-param-reassign */
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import CheckCircleOutlineRoundedIcon from '@material-ui/icons/CheckCircleOutlineRounded';
import CancelIcon from '@material-ui/icons/Cancel';
import { CardBody, CardTitle, Card } from 'reactstrap';
import moment from 'utils/moment';
import Clickable from '../../../components/clickable/Clickable';
import Modal from '../../../components/modal/modal';
import FileSlider from '../../../components/photoCarousel/FileSlider';
import styles from '../../../styles/general.module.scss';
import docStyles from '../document.module.scss';
import Styles from '../../gate-management/list.module.scss';
import styleses from '../../home/weather/Portal.module.scss';

const Table = ({ info, handleEdit, portal_all_required, groupByDocuments, handleReview, handleViewComments, profile }) => {
  const dateFormat = localStorage.getItem('dateFormat') || 'MM/DD/YYYY';
  const [modal, setModal] = useState(false);
  const [attachments, setAttachments] = useState([]);
  const [groupedByContractId, setGroupedByContractId] = useState({});
  const [actionDropdown, setActionDropdown] = useState(false);
  const [popupId, setPopupId] = useState('');

  useEffect(() => {
    if (groupByDocuments && info?.length > 0) {
      const groupedByContract = info?.reduce((acc, doc) => {
        if (doc.portal_options?.docsign?.steps) {
          let docment = doc.portal_options?.docsign?.steps?.find(step => (step.status === 'Completed' && step.show_in === 'portal' && step.signer_email === profile.user.email) || (step.status === 'Pending' && step.show_in === 'portal' && step.routing_order === doc.portal_options?.docsign?.current_routing_order && step.signer_email === profile.user.email));
          if (docment) {
            if (!acc[doc?.contract_id]) {
              acc[doc.contract_id] = [];
            }
            doc.portal_options.docsign.status = docment.status;
            acc[doc.contract_id].push(doc);
          }
        } else {
          if (!acc[doc?.contract_id]) {
            acc[doc.contract_id] = [];
          }
          acc[doc.contract_id].push(doc);
        }
        return acc;
      }, {});
      setGroupedByContractId(groupedByContract);
    }
  }, [info]);

  const openPhotoModal = (attachments) => {
    setModal(true);
    setAttachments(attachments);
  };

  const hideSection = (value) => {
    const element = document.getElementById(value);
    if (window.getComputedStyle(element, null).display === 'none') {
      element.style.display = '';
    } else {
      element.style.display = 'none';
    }
  };

  const getDisplayText = (attachments) => {
    if (attachments.length > 1) {
      return 'Documents';
    }
      return attachments[0]?.file_name === '' ? 'Documents' : attachments[0]?.file_name;
  };

  const renderStatus = (val) => {
    const hasAttachments = (val?.attachments?.length > 0 || val?.drive_attachments?.length > 0);
    const isValidDate = val?.valid_date ? new Date(val.valid_date).setHours(0, 0, 0, 0) >= new Date().setHours(0, 0, 0, 0) : false;
    if (val?.valid_date === null && hasAttachments) {
      return null;
    }
    if (hasAttachments && isValidDate) {
      if (val?.status === 'approve') {
        return (
          <div className={`${styles.active} ${styles.btnWidth}`}>
            <FormattedMessage id="document.table.active" defaultMessage="Active" />
          </div>
        );
      } if (val?.status === 'reject') {
        return (
          <div className={`${styles.rejected} ${styles.btnWidth}`}>
            <FormattedMessage id="document.table.rejected" defaultMessage="Rejected" />
          </div>
        );
      }
      if (val?.portal_options?.updated_source === 'portal') {
        return (
          <div className={`${styles.orange_color} ${styles.btnWidth}`}>
            <FormattedMessage id="document.table.pending.approval" defaultMessage="Pending Approval" />
          </div>
        );
      }
      return (
        <div className={`${styles.active} ${styles.btnWidth}`}>
          <FormattedMessage id="document.table.active" defaultMessage="Active" />
        </div>
      );
    }

    if (hasAttachments && !isValidDate) {
      return (
        <div className={`${styles.orange_color} ${styles.btnWidth}`}>
          <FormattedMessage id="document.table.expired" defaultMessage="Expired" />
        </div>
      );
    }

    return (
      <div className={`${styles.orange_color} ${styles.btnWidth}`}>
        <FormattedMessage id="document.table.pending" defaultMessage="Pending Upload" />
      </div>
    );
  };

  const handleDropDown = (docId) => {
    setActionDropdown(!actionDropdown);
    setPopupId(docId);
  };

  const tablebodyInfo = (e) => {
    const portalStatus = e?.portal_options?.docsign?.status;
    return (
      <tr key={e.id}>
        <td>
          <div className={styles.required}>
            {e?.required && (
              <>
                {(e?.attachments?.length > 0 || e?.drive_attachments?.length > 0) ? (
                  <div className={styles.tick}>
                    <CheckCircleOutlineRoundedIcon />
                  </div>
                ) : (
                  <div className={styles.pending}>
                    <CancelIcon />
                  </div>
                )}
              </>)}
            {portalStatus !== undefined && (
              <>
                {(e?.attachments?.length > 0 || e?.drive_attachments?.length > 0) ? (
                  <div className={styles.tick}>
                    <CheckCircleOutlineRoundedIcon />
                  </div>
                ) : (
                  <div className={styles.pending}>
                    <CancelIcon />
                  </div>
                )}
              </>)}
            <span className="text-truncate" style={{ width: '150px', cursor: 'pointer' }} title={e?.document_type || ''}>{e?.document_type}</span>
          </div>
        </td>
        <td className="text-truncate" style={{ width: '120px', cursor: 'pointer' }} title={e?.description || ''}>{e?.description || ''}</td>
        <td>
          <div className={docStyles.name}>
            {(e?.attachments?.length > 0 || e?.drive_attachments?.length > 0) && (
              <Clickable
                key={e.id}
                onClick={() => openPhotoModal([...e?.attachments || [], ...e?.drive_attachments || []])}
                className={docStyles.documentLink}
              >
                {e?.attachments?.length > 0 && e?.drive_attachments?.length === 0
                  ? getDisplayText(e.attachments)
                  : e?.drive_attachments?.length > 0 && e?.attachments?.length === 0
                    ? getDisplayText(e.drive_attachments)
                    : 'Documents'}
              </Clickable>
            )}
          </div>
        </td>
        <td className={styles.date}>
          {portalStatus === 'Pending' ? '' : (e.valid_date && moment(e.valid_date))?.format(dateFormat)}
        </td>
        <td>
          {portalStatus !== undefined
            ? (<div className={`${(portalStatus === 'Pending' ? styles.orange_color : styles.active)} ${styles.btnWidthCompleted}`}>
              <FormattedMessage id={portalStatus === 'Pending' ? 'document.table.pending.signature' : 'document.table.completed'}
                defaultMessage={portalStatus === 'Pending' ? 'Pending Signature' : 'Completed'}
              />
               </div>)
            : renderStatus(e)
          }
        </td>
        <td>
          {portalStatus !== undefined
            ? <>
              {portalStatus === 'Pending' && (
                  <Clickable onClick={() => handleReview(e?.portal_options?.docsign?.envelope_id)} className={styles.color}>
                    <FormattedMessage id="invoices.list.action" defaultMessage="Review & Sign" />
                  </Clickable>
              )}
              </>
            : <>
              <Clickable
                className={`${styles.actionsBtn} ${Styles.actionsBtn}`}
                onClick={() => handleDropDown(e.id)}
              >
                <FormattedMessage
                  id="workorders.detail.actionBtn"
                  defaultMessage="Actions"
                />
              </Clickable>
              {actionDropdown && (popupId === e.id) && (
                <ul className={`${Styles.actionpopup} ${actionDropdown ? Styles.open : ''}`}>
                  {(e.portal_options?.portal_edit === true || (e.required === true && portal_all_required === true)) && (
                    <li className={Styles.item}>
                      <Clickable onClick={() => { handleEdit(e); setActionDropdown(!actionDropdown); }} className={styles.color}>
                        <FormattedMessage id={(e?.attachments?.length > 0 || e?.drive_attachments?.length > 0)
                         ? 'workorders.edit.update' : 'invoices.list.table.action'}
                          defaultMessage={(e?.attachments?.length > 0 || e?.drive_attachments?.length > 0) ? 'Update' : 'Upload'} />
                      </Clickable>
                    </li>)}
                    <li className={Styles.item}>
                      <Clickable onClick={() => { handleViewComments(e); setActionDropdown(!actionDropdown); }} className={styles.color}>
                        <FormattedMessage id={'workorders.view.comments'} defaultMessage={'View Comments'} />
                      </Clickable>
                    </li>
                </ul>
              )}
              </>}
        </td>
      </tr>
    );
  };

  return (
    <Card className={styleses.card} style={{ border: 'none', width: '100%' }}>
      <CardTitle className={styleses.Cardtitle}>
        Tenant Documents
      </CardTitle>
      <CardBody style={{ padding: '0px' }}>
        <table className={styles.table} style={{ border: 'none', borderTop: '1px solid #E6EAEE' }}>
          <thead>
            <tr>
              <th className="text-truncate">
                <FormattedMessage id="document.list.type" defaultMessage="Document Type" />
              </th>
              <th className="text-truncate">
                <FormattedMessage id="document.list.description" defaultMessage="Description" />
              </th>
              <th style={{ width: '20%' }} className="text-truncate">
                <FormattedMessage id="document.list.docName" defaultMessage="Document" />
              </th>
              <th className="text-truncate">
                <FormattedMessage id="document.list.valid_date" defaultMessage="Valid Until" />
              </th>
              <th className="text-truncate">
                <FormattedMessage id="workorders.list.table.status" defaultMessage="Status" />
              </th>
              <th className="text-truncate">
                <FormattedMessage id="assets.Action" defaultMessage="Action" />
              </th>
            </tr>
          </thead>
          {groupByDocuments
            ? Object.keys(groupedByContractId) && Object.keys(groupedByContractId)?.length > 0 && (
              Object.keys(groupedByContractId)?.map(k => (
                <React.Fragment key={k}>
                  <thead className={styles.sectionHeader} style={{ textAlign: 'left' }}>
                    <tr
                      onClick={() => hideSection(`table-${k}`)}
                      onKeyPress={() => hideSection(`table-${k}`)}
                    >
                      <th colSpan={12} className={styles.tableHeading}>
                        <div className={styles.label}>
                          {k === 'null' ? 'No Contract' : groupedByContractId[k]?.length > 0 && groupedByContractId[k][0]?.contract_name}
                        </div>
                      </th>
                    </tr>
                  </thead>
                  {groupedByContractId[k] && (
                    <tbody id={`table-${k}`}>
                      {groupedByContractId[k]?.map(e => (
                        tablebodyInfo(e)
                      ))}
                    </tbody>
                  )}
                </React.Fragment>
              )))
            : <tbody>
              {!info.length > 0 ? (
                <tr>
                  <td className="noTableData" colSpan={5}>
                    <FormattedMessage id="invoice.list.table.no_results" defaultMessage="There are no documents for this tenant" />
                  </td>
                </tr>
              )
                : (
                  info.map(e => (
                    tablebodyInfo(e)
                  ))
                )}
              </tbody>}
          {attachments && attachments?.length > 0 && (
            <Modal
              showIn={modal}
              onClose={() => {
                setModal(false);
                setAttachments([]);
              }}
              contentStyles={{
                overflow: 'visible',
                background: '#E6EAEE',
                padding: '20px 40px'
              }}
            >
              <FileSlider photos={attachments} initialSlide={0} />
            </Modal>
          )}
        </table>
      </CardBody>
    </Card>
  );
};

Table.propTypes = {
  info: PropTypes.arrayOf(PropTypes.shape({})).isRequired
};
export default Table;
